import WingHero from "../components/WingHero";
import WingPrograms from "../components/WingPrograms";
import WingPathwayNav from "../components/WingPathwayNav";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { wingDetails } from "@/mocks/programsData";

const wingData = wingDetails.find((w) => w.wing === "Readiness & Recognition")!;

export default function ReadinessWingPage() {
  return (
    <main className="min-h-screen">
      <WingHero
        badge="Readiness & Recognition"
        title="Readiness & Recognition"
        subtitle={wingData.tagline}
        description={wingData.description}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      {/* What Is Section */}
      <section className="bg-tie-grey-light py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-10">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-amber-500/10 mb-4 md:mb-6">
                  <span className="text-xs font-semibold text-amber-600 uppercase tracking-wider">
                    / What This Wing Does
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                  Prove It. Certify It. Celebrate It.
                </h2>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={150}>
              <div className="space-y-4 md:space-y-5">
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  Innovation means nothing if it cannot be verified. The Readiness & Recognition Wing ensures
                  that every improvement is independently assessed, certified, and communicated to buyers,
                  investors, and the public. This wing protects credibility by making evidence the price of entry.
                </p>
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  From the Innovation Readiness Certification — with its Bronze, Silver, and Gold tiers — to the
                  annual Textile Innovation Awards requiring baseline and endline proof, this wing turns
                  intangible innovation culture into marketable, defensible credibility.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="mt-8 md:mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { label: "Certification Tiers", value: "3" },
                  { label: "Award Categories", value: "4+" },
                  { label: "Assessment Areas", value: "11" },
                  { label: "Evidence Standard", value: "100%" },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-4 md:p-5 rounded-xl bg-white border border-tie-grey-dark">
                    <p className="font-serif text-2xl md:text-3xl font-bold text-tie-navy mb-1">{stat.value}</p>
                    <p className="text-xs md:text-sm text-tie-text-muted">{stat.label}</p>
                  </div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <WingPrograms
        title="Programmes in Readiness & Recognition"
        programs={wingData.items}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      <WingPathwayNav />
    </main>
  );
}